/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { Image } from 'shared';
import {
    Box, Flex, Grid, Heading,
} from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { Carousel } from 'shared/ui/Carousel';
import {
    useImagesBlockState,
} from '../store';

export type ImagesBlockProps = {
    className?: string
}

export const ImagesBlock = () => {
    const { images } = useImagesBlockState();

    const [open, setOpen] = useState(false);

    const onMouseEnter = () => setOpen(true);

    const onMouseLeave = () => setOpen(false);

    return (
        <Grid>
            <Flex
                maxWidth={{
                    base: '425px',
                    lg: '1280px',
                }}
                width="100%"
                margin="0 auto"
                padding="2rem"
                background="white"
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                {/* <div className={styles.portfolioBlock__sidebar}>
                    <Image
                        className={styles.portfolioBlock__image}
                        src={image?.url || ''}
                    />
                </div> */}
                <Grid gap="2rem">
                    <Grid
                        templateColumns={{ base: '1fr', lg: 'auto 1fr' }}
                        gap="2rem"
                    >
                        <Heading size="lg">
                            ФОТО С НАШИХ МЕРОПРИЯТИЙ
                        </Heading>
                        <Box margin="auto 0" background="black" height="4px" display={{ base: 'none', lg: 'block' }} />
                    </Grid>
                    <Carousel
                        maxWidth={{
                            base: '361px',
                            lg: '1216px',
                        }}
                        spacing="2rem"
                        withDialog
                        slidesPerPage={1.2}
                        data-state={open ? 'open' : 'closed'}
                        autoplay={open ? false : { delay: 10000 }}
                        items={images.map(({
                            url,
                        }) => (
                            <Image
                                aspectRatio="3 / 2"
                                width="100%"
                                objectFit="cover"
                                src={url}
                            />
                        ))}
                    />
                </Grid>
            </Flex>
        </Grid>
    );
};
